<template>
  <div class="head_box">
    <div class="wzbox" v-if="$store.state.usercenter.userDialog"></div>
    <div class="head-page">
      <div class="head_left">
        <div class="head_logo" @click="changeTap(1)">
          <img :src="`${$publickCdn}static/broadcast/img/live_logo.png`" alt />
          <span>{{$t('开播管理')}}</span>
        </div>
        <ul>
          <li
            v-for="item in tabul"
            :class="{'active':$store.state.usercenter.asideIndex == item.indexs}"
            :key="item.id"
            @click="changeTap(item.indexs)"
          >{{ $t(item.name) }}</li>
        </ul>
      </div>
      <div
        class="head-avatarbox"
        @mouseenter="userinfoshow = true"
        @mouseleave="userinfoshow = false"
      >
        <div class="logoimg" @click="gomyinfo" :key="$store.state.usercenter.userinfo.portrait">
          <div class="lazy_portrait">
            <avatarLazy :lazyimg="$store.state.usercenter.userinfo.portrait"></avatarLazy>
          </div>
        </div>
        <!-- 触摸弹起来的个人中心栏目 v-show="userinfoshow" -->
        <div class="userinfo_box" v-show="userinfoshow">
          <!-- <div class="userinfo_box"> -->
          <div class="userinfo_detail">
            <div class="user_top">
              <div class="arrow-box">
                <i class="arrow el-icon-caret-top"></i>
              </div>
              <div
                class="userinfo_portrait"
                :key="$store.state.usercenter.userinfo.portrait+'2222'"
              >
                <div
                  class="lazy_portrait"
                  v-if="userinfoshow"
                  :key="$store.state.usercenter.userinfo.portrait+'2222'"
                >
                  <avatarLazy :lazyimg="$store.state.usercenter.userinfo.portrait"></avatarLazy>
                </div>
                <input
                  type="file"
                  title
                  id="change"
                  @click="userinfoshow = false"
                  accept="image"
                  @change="change($event)"
                />
                <label for="change"></label>
                <div class="boshow" @click.stop="openCropper">{{$t('点击修改')}}</div>
                <!-- <Cropper/> -->
              </div>
              <div class="user_main">
                <div class="line_one">
                  <div class="name_icon">
                    <span class="names">{{$store.state.usercenter.userinfo.user_nickname}}</span>
                    <span
                      class="chatLevelbrand item_level_lv31_35"
                    >{{$store.state.usercenter.userinfo.grade}}</span>
                    <img
                      v-if="isHoverEdit"
                      class="modify"
                      @click.stop="ediorname"
                      @mouseenter="isHoverEdit=false"
                      :src="`${$publickCdn}static/broadcast/img/editor_w.png`"
                    />
                    <img
                      v-else
                      class="modify"
                      @click.stop="ediorname"
                      @mouseleave="isHoverEdit=true"
                      :src="`${$publickCdn}static/broadcast/img/editor_b.png`"
                    />
                  </div>
                  <div class="exitBtn" @click="exitLogin">{{$t('退出')}}</div>
                </div>
                <div class="line_tow">
                  {{$t('已加入直播平台')}}
                  <span>{{$store.state.usercenter.userinfo.reg_days}}</span>
                  {{$t('天')}}
                </div>
                <div class="line_three">
                  <span class="level">LV.{{$store.state.usercenter.userinfo.grade}}</span>
                  <div class="bar">
                    <div class="bar_bg"></div>
                    <div class="drawbar" ref="bars" style="width:204px"></div>
                    <div
                      class="text"
                    >{{$store.state.usercenter.userinfo.experience}}/{{$store.state.usercenter.userinfo.next_experience}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="user_bottom">
              <span class="balet">{{$t('我的钱包')}}</span>
              <div class="balance">
                <div class="glod-box">
                  <img :src="`${$publickCdn}static/broadcast/img/coins.png`" alt />
                  <span>{{formatNumber($store.state.usercenter.userinfo.coin_num)}}</span>
                </div>
                <div class="diamond-box">
                  <img :src="`${$publickCdn}static/broadcast/img/diamondsIcon.png`" alt />
                  <span>{{formatNumber($store.state.usercenter.userinfo.diamond_num)}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="demo" v-if="panel">
        <div class="container">
          <div class="panelcls">
            <div class="title">
              <span class="logo">{{$t('修改头像')}}</span>
              <img :src="`${$publickCdn}static/broadcast/img/xx.png`" class="xx" @click="qx" />
            </div>
            <div class="content">
              <div class="content_left">
                <!-- <img :src="url" alt=""> -->
                <div class="square previewImg"></div>
                <!-- preview : '.previewImg' -->
              </div>
              <div class="coantent_right">
                <img :src="url" id="image" alt />
              </div>
            </div>
            <div class="btn">
              <span>{{$t('图片格式：仅支持png、jpg')}}</span>
              <button id="bubtton" @click="crop">{{$t('确认')}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 导入上传图片组件

// import cropperMixins from '../components/cropperJs/cropper'
import evenbus from '@/utils/eventBus.js'
import Moment from 'moment'
import Cropper from 'cropperjs'
import { compressAccurately } from 'image-conversion'
import * as qiniu from 'qiniu-js'
export default {
  name: 'pageheader',
  // mixins:[cropperMixins],
  data() {
    return {
      userinfoshow: false,
      clickshow: false,
      isHoverEdit: true,
      headerImage: '',
      picValue: '',
      cropper: '',
      croppable: false,
      panel: false,
      url: '',
      files: null,
      // 文件上传-腾讯云
      domain: '',
      bucket: '',
      region: '',
      cos: '',
      prefix: '',
      uploadToken: '',
      uploadFile: '',
      uploadFileName: '',
      uploadFileType: '',
      url1: '',
      BucketRegion: '',
      sign: '',
      filesname: '',
      tabul: [
        { name: '首页', indexs: 1 },
        { name: '赛程', indexs: 2 },
      ],
    }
  },
  created() {
    if (window.localStorage.getItem('token')) {
      this.getUserinfo()
    }
  },
  methods: {
    changeTap(indexs) {
      this.$store.commit('setasideIndex', indexs)
      window.sessionStorage.setItem('setasideIndex', indexs)
    },
    gomyinfo() {
      this.$store.commit('setasideIndex', 10)
      window.sessionStorage.setItem('setasideIndex', 10)
      setTimeout(() => {
        evenbus.$emit('changetab', 0)
      }, 100)
    },
    formatNumber(n) {
      n = n || 0
      let num = n.toString()
      let decimals = ''
      // 判断是否有小数
      num.indexOf('.') > -1 ? (decimals = num.split('.')[1]) : decimals
      let len = num.length
      if (len <= 3) {
        return num
      } else {
        let temp = ''
        let remainder = len % 3
        decimals ? (temp = '.' + decimals) : temp
        if (remainder > 0) {
          // 不是3的整数倍
          return (
            num.slice(0, remainder) +
            ',' +
            num.slice(remainder, len).match(/\d{3}/g).join(',') +
            temp
          )
        } else {
          // 是3的整数倍
          return num.slice(0, len).match(/\d{3}/g).join(',') + temp
        }
      }
    },
    ediorname() {
      this.$store.commit('setasideIndex', 10)
      window.sessionStorage.setItem('setasideIndex', 10)
      setTimeout(() => {
        evenbus.$emit('changetab', 1)
      }, 100)
    },
    exitLogin() {
      // 退出登录
      this.$api
        .loginout({})
        .then((res) => {
          if (res.code == 200) {
            this.$store.commit('setToken', '') //保存token
            this.$store.commit('setUserIfno', {})
            this.$message.success({
              message: this.$t('退出成功'),
              type: 'success',
              offset: 210,
              duration: 1500,
            })
            this.$router.push('/login')
          }
        })
        .catch((erro) => {})
    },
    getUserinfo() {
      this.$store
        .dispatch('getUserInfo')
        .then((data) => {
          if (data && data.chatroom_id) {
            this.$store.commit('setUserIfno', data)
          } else {
          }
        })
        .catch((erro) => {})
    },
    getObjectURL(file) {
      var url = null

      if (window.createObjectURL != undefined) {
        // basic

        url = window.createObjectURL(file)
      } else if (window.URL != undefined) {
        // mozilla(firefox)

        url = window.URL.createObjectURL(file)
      } else if (window.webkitURL != undefined) {
        // webkit or chrome

        url = window.webkitURL.createObjectURL(file)
      }

      return url
    },
    showcropper() {
      //初始化这个裁剪框
      var self = this
      var image = document.getElementById('image')
      if (!image) return
      this.cropper = new Cropper(image, {
        aspectRatio: 1,
        preview: '.previewImg',
        viewMode: 1,
        background: false,
        zoomable: true,
        zoomOnWheel: true,
        cropBoxMovable: true,
        cropBoxResizable: true,

        ready: function () {
          self.croppable = true
        },
      })
    },
    change(e) {
      let files = e.target.files || e.dataTransfer.files
      this.files = files
      this.filesname = files[0].name
      let isimg = this.isImg(this.getUploadUrlSuffix(files[0].name))
      // isImg(getUploadUrlSuffix(img))
      if (isimg) {
        this.$message.error({
          message: this.$t('图片格式：仅支持png、jpg'),
          type: 'error',
          offset: 210,
          duration: 1500,
        })
        var obj = document.getElementById('change')
        if (obj) obj.value = ''
        this.panel = false
        this.cropper = null
        this.$store.commit('setCroopDialog', false)
        this.picValue = ''
        this.url = ''
        return
      }
      // 这里让它弹起来
      this.panel = true
      this.$store.commit('setCroopDialog', true)
      this.picValue = files[0]

      this.url = this.getObjectURL(this.picValue)

      if (this.cropper) {
        this.cropper.replace(this.url)
      }

      //每次替换图片要重新得到新的url
      this.$nextTick(() => {
        this.showcropper()
      })
    },
    isImg(str) {
      if (str.search('[.]+(jpg|jpeg|png|JPG|JPEG|PNG)$')) {
        return true
      }
    },
    // 截取url后面的文件类型
    getUploadUrlSuffix(urlStr) {
      var url = urlStr.substring(urlStr.lastIndexOf('.'), urlStr.length)
      return url
    },
    // 确定上传
    crop() {
      this.panel = false
      this.$store.commit('setCroopDialog', false)
      if (!this.croppable) {
        return
      }
      let dataurl = this.cropper.getCroppedCanvas().toDataURL()
      this.headerImage = dataurl

      this.postImg()
    },
    // 取消上传
    qx() {
      var obj = document.getElementById('change')
      if (obj) obj.value = ''
      this.panel = false
      this.cropper = null
      this.$store.commit('setCroopDialog', false)
      this.picValue = ''
      this.url = ''
    },
    getRoundedCanvas(sourceCanvas) {
      var canvas = document.createElement('canvas')

      var context = canvas.getContext('2d')

      var width = sourceCanvas.width

      var height = sourceCanvas.height

      canvas.width = width

      canvas.height = height

      context.imageSmoothingEnabled = true

      context.drawImage(sourceCanvas, 0, 0, width, height)

      context.globalCompositeOperation = 'destination-in'

      context.beginPath()

      context.fill()

      return canvas
    },

    postImg() {
      //这边写图片的上传
      const changeInput = document.getElementById('change')
      if (changeInput) changeInput.value = ''
      let files = this.dataURLtoFile(this.headerImage, this.filesname)
      this.beforeAvatarUpload(files)
    },
    /**
          * base64转文件
           // * @param dataurl:图片的链接或者base64,filename:图片的名称
           * **/
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, {
        type: mime,
      })
    },
    beforeAvatarUpload(file) {
      // 再上传钱做一个图片压缩大小操作
      // 首先判断图片是不是标准图片。不是就返回，是的话就判断大小压缩
      this.conversiones(file).then((files) => {
        // 1.9.8版本改成im上传图片
        const that = this
        this.$api.uploadPic({ file: files }).then((res) => {
          if (res.code == 200) {
            that.headerImage = res.data.img_url
            that.saveEdit()
          }
        })
        return
        this.uploadFile = files
        this.uploadFileName = file.name
        let uploadFileType = files.type
        this.uploadFileType = uploadFileType.slice(6)
        //将图片文件上传七牛云服务器
        this.getSign()
      })
    },
    conversiones(file) {
      return new Promise((resolve, reject) => {
        let isLt2M = file.size / 1024 / 1024 < 1 // 判定图片大小是否小于1MB
        if (isLt2M) {
          resolve(file)
          return
        }
        // 压缩到1024KB,这里的1024就是要压缩的大小,可自定义
        compressAccurately(file, 980).then((res) => {
          // console.log(res)
          resolve(res)
        })
      })
    },
    // 获取腾讯云配置参数
    //  getTenCloudConfig() {
    //   return new Promise((resolve,reject)=>{
    //     this.$api.getTenCloudConf().then((res)=>{
    //       resolve(res)
    //     })
    //   })
    //  },
    // 获取腾讯云临时密钥
    //  getSecretKey() {
    //   return new Promise((resolve,reject)=>{
    //     this.$api.getSecretKey().then((res)=>{
    //       resolve(res)
    //     })
    //   })
    //  },
    // 格式化时间戳
    dateAdjustByBeiJing(match_time) {
      let isMiniSecond = (match_time + '').length >= 13
      let date = new Date(isMiniSecond ? match_time : match_time * 1000)
      let localTime = isMiniSecond ? match_time : match_time * 1000
      let localOffset = date.getTimezoneOffset() * 60000 //获得当地时间bai偏移的毫du秒数
      let utc = localTime + localOffset //utc即GMT时间
      let offset = 8 //以北京时间为例zhi，东10区
      let gtm = utc + 3600000 * offset
      return gtm
    },
    getSign() {
      //  Promise.all([this.getTenCloudConfig(), this.getSecretKey()])
      //    .then((value)=>{
      //        this.BucketRegion = {...value[0].data}
      //        this.sign = {...value[1].data};
      //        this.upLoad()
      //    });
      let that = this
      //  console.log('我是最终的文件',this.uploadFile)
      this.$api.getSecretKey().then((res) => {
        // console.log('xxxx',res)
        if (res.code == 200) {
          this.uploadToken = res.data.token
          this.prefix = res.data.prefix
          let timestamp = new Date().getTime()
          let fileboxnametime = Moment(that.dateAdjustByBeiJing(timestamp))
            .format('YYYYMMDD')
            .toString()
          let filenametime = Moment(that.dateAdjustByBeiJing(timestamp))
            .format('YYYYMMDDHHmmss')
            .toString()
          let files = this.uploadFile
          let Key =
            'portrait/' +
            'public' +
            '/' +
            fileboxnametime +
            '/' +
            this.$store.state.usercenter.userinfo.userid +
            '/' +
            filenametime +
            '.' +
            this.uploadFileType
          // let Key =  this.uploadFileName
          let token = this.uploadToken
          const putExtra = {
            fname: this.uploadFileName, // 文件原文件名
            params: {}, // 用来放置自定义变量
            mimeType: null, // 用来限制上传文件类型，为 null 时表示不对文件类型限制；eg: ["image/png", 	  "image/jpeg"]
          }
          const config = {
            useCdnDomain: true,
            region:
              qiniu.region[process.env.VUE_APP_INTER == '2' ? 'as0' : 'z2'], //区域
          }
          // console.log('pppp',files,Key,token,putExtra,config,this.uploadFileType)
          const observable = qiniu.upload(files, Key, token, putExtra, config)
          observable.subscribe({
            next(res) {},
            error(err) {},
            complete(res) {
              //来到这里就是上传成功了。。
              let url = that.prefix + '/' + res.key
              that.headerImage = url
              that.saveEdit()
            },
          })
        }
      })
    },
    //   upLoad() {
    //    let timestamp = (new Date()).getTime();
    //    let filenametime = Moment(timestamp).format("YYYYMMDDHHmmss").toString();
    //    let fileboxnametime = Moment(timestamp).format("YYYYMMDD").toString();
    //    let that = this
    //    let cos = new COS({
    //      getAuthorization: function(options, callback){
    //        callback({
    //          TmpSecretId: that.sign.credentials.tmpSecretId,
    //          TmpSecretKey: that.sign.credentials.tmpSecretKey,
    //          XCosSecurityToken: that.sign.credentials.sessionToken,
    //          StartTime: that.sign.startTime,
    //          ExpiredTime: that.sign.expiredTime,
    //          expiration: that.sign.expiration,
    //          requestId: that.sign.requestId
    //        })
    //      }
    //    })
    //    cos.putObject(
    //      {
    //        Bucket: that.BucketRegion.bucket,
    //        Region: that.BucketRegion.region,
    //        Key: 'portrait/' + fileboxnametime +'/'+ that.$store.state.usercenter.userinfo.userid + '/' + filenametime +'.'+that.uploadFileType,
    //        StorageClass: 'STANDARD',
    //        Body: that.uploadFile, // 上传文件对象
    //        onProgress: function(progressData) {
    //        }
    //      },
    //      function(err, data) {
    //        if (data && data.statusCode === 200) {
    //          const url = that.BucketRegion.domain + 'portrait/' + fileboxnametime +'/'+ that.$store.state.usercenter.userinfo.userid + '/' + filenametime +'.'+that.uploadFileType; //根据对应路径获取到url
    //          that.headerImage = url
    //          that.saveEdit()
    //        }
    //      }
    //    )
    //  },
    saveEdit() {
      this.$api
        .editorUser({ portrait: this.headerImage })
        .then((response) => {
          if (response.code === 200) {
            this.$message.success({
              message: this.$t('修改头像成功'),
              type: 'success',
              offset: 210,
              duration: 1500,
            })
          }
          this.getUserinfo()
        })
        .catch((error) => {})
    },
  },
}
</script>

<style scoped lang="less">
@media screen and (max-width: 1680px) {
  .head_box {
    // height: 48px !important;
    min-width: 1350px;
    .name {
      font-size: 20px !important;
    }
  }
  .head-page {
    width: 1260px !important;
  }
}
.head_box {
  position: fixed;
  top: 0px;
  display: flex;
  height: 64px;
  z-index: 2005;
  min-width: 1815px;
  width: 100%;
  padding-left: 90px;
  width: 100%;
  background-color: white;
  .wzbox {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 2002;
  }
}
.head-page {
  width: 100%;
  // height: 100%;
  padding-left: 60px;
  width: 1720px;
  display: flex;
  flex-direction: row;
  position: relative;
  justify-content: space-between;
  align-items: center;
  .name {
    font-size: 24px;
    font-weight: 600;
    color: #222222;
  }
  .head_left {
    display: flex;
    flex-direction: row;
    align-items: center;
    .head_logo {
      display: flex;
      flex-direction: row;
      cursor: pointer;
      align-items: center;
      img {
        width: 44px;
        height: 44px;
      }
      span {
        font-size: 24px;
        color: #222222;
        margin-left: 20px;
      }
    }
    ul {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-left: 40px;
      // width: 200px;
      li {
        width: auto;
        height: 30px;
        text-align: center;
        line-height: 30px;
        font-size: 18px;
        cursor: pointer;
        color: #222222;
        word-break: keep-all;
        padding: 0 10px;
      }
      li:first-child {
        margin-right: 20px;
      }
      li.active {
        color: #7e4f20;
        background: linear-gradient(270deg, #f1cb91 0%, #fce4bb 100%);
        border-radius: 10px 0px 10px 10px;
      }
    }
  }
  .head-avatarbox {
    width: 40px;
    height: 40px;
    position: relative;
    .logoimg {
      width: 38px;
      height: 38px;
      border-radius: 38px;
      cursor: pointer;
      .lazy_portrait {
        width: 38px;
        height: 38px;
        border: 1px solid #cf9652;
        border-radius: 38px;
        cursor: pointer;
      }
    }
    .userinfo_box {
      position: absolute;
      z-index: 2002;
      right: 0px;
      width: 380px;
      top: 35px;
      .userinfo_detail {
        margin-top: 23px;
        width: 100%;
        height: 160px;
        background-color: white;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
        border-radius: 6px;
        .user_top {
          position: relative;
          display: flex;
          flex-direction: row;
          border-radius: 6px 6px 0px 0px;
          padding: 19px 19px;
          align-items: center;
          width: 100%;
          height: 111px;
          background: linear-gradient(270deg, #eec383 0%, #f8e3b9 100%);
          box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
          .userinfo_portrait {
            width: 66px;
            height: 66px;
            border-radius: 66px;
            overflow: hidden;
            position: relative;
            .lazy_portrait {
              width: 100%;
              height: 100%;
              border-radius: 66px;
            }
            .boshow {
              width: 66px;
              cursor: pointer;
              display: none;
              height: 66px;
              border-radius: 60px;
              position: absolute;
              left: 0px;
              top: 0px;
              background: rgba(0, 0, 0, 0.5);
              text-align: center;
              line-height: 66px;
              font-size: 12px;
              font-weight: 500;
              color: #ffffff;
              z-index: 1;
            }
            input {
              width: 66px;
              z-index: 2;
              display: inline-block;
              opacity: 0;
              cursor: pointer;
              height: 66px;
              border-radius: 60px;
              position: absolute;
              left: 0px;
              top: 0px;
              background: rgba(0, 0, 0, 0.5);
              text-align: center;
              line-height: 66px;
              font-size: 12px;
              font-weight: 500;
              color: #ffffff;
            }
            label {
              width: 66px;
              z-index: 3;
              display: inline-block;
              opacity: 0;
              cursor: pointer;
              height: 66px;
              border-radius: 60px;
              position: absolute;
              left: 0px;
              top: 0px;
              background: rgba(0, 0, 0, 0.5);
              text-align: center;
              line-height: 66px;
              font-size: 12px;
              font-weight: 500;
              color: #ffffff;
            }
          }
          .userinfo_portrait:hover {
            .boshow {
              display: block;
            }
          }
          .user_main {
            margin-left: 10px;
            flex: 1;
            .line_one {
              width: 100%;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              .name_icon {
                display: flex;
                flex-direction: row;
                align-items: center;
                .names {
                  max-width: 120px;
                  height: 23px;
                  font-size: 18px;
                  font-family: HiraginoSansGB-W3, HiraginoSansGB;
                  font-weight: normal;
                  color: #7e4f20;
                  line-height: 18px;
                  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  padding-top: 2px;
                }
                .chatLevelbrand {
                  display: inline-block;
                  vertical-align: middle;
                  margin-left: 5px;
                  width: 37px;
                  height: 22px;
                  line-height: 22px;
                  text-align: center;
                  color: rgba(255, 255, 255, 0.8);
                  padding-left: 12px;
                  font-size: 12px;
                  margin-left: 6px;
                }
                .item_level_lv31_35 {
                  background: url('@{publickImg}static/broadcast/img/level_lv31_35.png')
                    100% 100% no-repeat;
                  background-size: 100% 100%;
                }
                .modify {
                  width: 16px;
                  height: 16px;
                  margin-left: 8px;
                  cursor: pointer;
                }
              }
              .exitBtn {
                margin-right: 6px;
                cursor: pointer;
                font-size: 12px;
                color: #fff;
                &:hover {
                  color: #6a3e14;
                }
              }
            }
            .line_tow {
              height: 14px;
              margin-top: 8px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #7e4f20;
              line-height: 14px;
              text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
            }
            .line_three {
              display: flex;
              align-items: center;
              flex-direction: row;
              margin-top: 14px;
              .level {
                font-size: 12px;
                font-weight: normal;
                color: #7e4f20;
                line-height: 12px;
                text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
              }
              .bar {
                width: 204px;
                height: 12px;
                margin: 0px 4px;
                position: relative;
                overflow: hidden;
                .bar_bg {
                  position: absolute;
                  left: 0px;
                  top: 0px;
                  width: 204px;
                  height: 12px;
                  background: #e6eaf3;
                  border-radius: 7px;
                  z-index: 1;
                }
                .drawbar {
                  position: absolute;
                  left: 0px;
                  top: 0px;
                  width: 100px;
                  z-index: 2;
                  height: 12px;
                  border-radius: 7px;
                  background: #cf9652;
                }
                .text {
                  position: absolute;
                  left: 50%;
                  top: 50%;
                  z-index: 3;
                  transform: translate(-50%, -50%);
                  font-size: 12px;
                  font-family: emoji;
                  line-height: 11px;
                  padding-top: 1px;
                  font-weight: normal;
                  color: #7e4f20;
                  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
                }
              }
            }
          }
        }
        .arrow-box {
          position: absolute;
          height: 20px;
          width: 100%;
          top: -16px;
          text-align: right;
          .arrow {
            position: absolute;
            top: -2px;
            right: 20px;
            font-size: 32px;
            color: #eec383;
            position: absolute;
          }
        }
        .user_bottom {
          width: 100%;
          padding: 0px 20px;
          height: 49px;
          border-radius: 0px 0px 6px 6px;
          display: flex;
          //  flex-direction: row;
          justify-content: space-between;
          align-items: center;
          .balance {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
          }
        }
        .balet {
          font-size: 16px;
          font-weight: normal;
          color: #222222;
          line-height: 16px;
          text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
        }
        .glod-box {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-right: 15px;
          img {
            width: 16px;
            height: 16px;
            vertical-align: middle;
          }
          span {
            font-size: 14px;
            font-weight: normal;
            color: #7e4f20;
            text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
            margin-left: 6px;
          }
        }
        .diamond-box {
          display: flex;
          flex-direction: row;
          align-items: center;
          img {
            width: 16px;
            height: 16px;
            vertical-align: middle;
          }
          span {
            font-size: 14px;
            font-weight: normal;
            color: #7e4f20;
            text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
            margin-left: 6px;
          }
        }
      }
    }
  }
}
</style>
<style >
#demo {
  position: absolute;
  right: 0px;
  top: 0px;
}
#demo #button {
  position: absolute;

  right: 10px;

  top: 10px;

  width: 80px;

  height: 40px;

  border: none;

  border-radius: 5px;

  background: white;
}

#demo .show {
  width: 66px;

  height: 66px;

  overflow: hidden;

  position: relative;

  border-radius: 50%;

  /* border: 1px solid #d5d5d5; */
}
#demo input {
  opacity: 0;
  position: absolute;
  z-index: 2004;
  left: 50%;
  top: 50%;
  cursor: pointer;
  transform: translate(-50%, -50%);
}
#demo label {
  opacity: 0;
}
#demo .clicks {
  position: absolute;
  z-index: 2002;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 12px;
  font-family: emoji;
  font-weight: 500;
  white-space: nowrap;
}
.backg {
  position: absolute;
  top: 0;
  left: 0;
  width: 66px;
  height: 66px;
  border-radius: 66px;
  background-color: rgba(0, 0, 0, 0.5);
}
#demo .picture {
  width: 100%;

  height: 100%;

  overflow: hidden;

  background-position: center center;

  background-repeat: no-repeat;

  background-size: cover;
}

#demo .container {
  z-index: 2100;

  position: fixed;

  display: flex;
  align-content: center;
  justify-content: center;

  left: 0;

  top: 0;

  right: 0;

  bottom: 0;

  background: rgba(0, 0, 0, 0.6);
}
#demo .container .panelcls {
  z-index: 2102;
  position: absolute;
  top: 15%;
  left: 50%;
  transform: translateX(-50%);
  width: 590px;
  height: 578px;
  background: #ffffff;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}
#demo .container .panelcls .title {
  padding: 0px 20px;
  height: 60px;
  background: #ffffff;
  border-radius: 10px 10px 0px 0px;
  border-bottom: 1px solid #e9ebf3;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
#demo .container .panelcls .title .logo {
  width: 66px;
  height: 16px;
  font-size: 16px;
  font-family: emoji;
  color: black;
  line-height: 16px;
}
#demo .container .panelcls .title .xx {
  width: 20px;
  height: 20px;
  cursor: pointer;
}
#demo .container .panelcls .content {
  width: 100%;
  height: 390px;
  padding: 40px 0px;
  flex: 1;
  display: flex;
  flex-direction: row;
}
#demo .container .panelcls .content .content_left {
  width: 30%;
  height: 390px;
  border-right: 1px solid #e9ebf3;
  display: flex;
  justify-content: center;
}
#demo .container .panelcls .content .coantent_right {
  width: 357px;
  height: 390px;
  margin-left: 20px;
  overflow: hidden;
}
#demo .container .panelcls .content .coantent_right .cropper-container {
  width: 357px !important;
  height: 390px !important;
}
#demo .container .panelcls .content .content_left .square {
  width: 140px !important;
  height: 140px !important;
  overflow: hidden !important;
  border-radius: 120px !important;
}
#demo .container .panelcls .btn {
  padding: 0px 20px;
  height: 60px;
  background: #ffffff;
  border-radius: 0px 0px 10px 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #e9ebf3;
}
#demo .container .panelcls .btn span {
  font-size: 14px;
  font-family: emoji;
  font-weight: normal;
  color: #999999;
  line-height: 21px;
}
#demo .container .panelcls .btn button {
  width: 80px;
  height: 35px;
  background: linear-gradient(270deg, #f1cb91 0%, #fce4bb 100%);
  border-radius: 6px 2px 6px 6px;
  cursor: pointer;
  outline: none;
  border: 0px;
  color: #7e4f20;
}
#demo .container .panelcls .btn button:hover {
  background: #f1cb91;
}
#demo #image {
  max-width: 100%;
}

.cropper-view-box,
.cropper-face {
  /* border-radius: 50%; */
}
.cropper-container {
  font-size: 0;

  line-height: 0;

  position: relative;

  -webkit-user-select: none;

  -moz-user-select: none;

  -ms-user-select: none;

  user-select: none;

  direction: ltr;

  -ms-touch-action: none;

  touch-action: none;
}

.cropper-container img {
  /* Avoid margin top issue (Occur only when margin-top <= -height) */

  display: block;

  min-width: 0 !important;

  max-width: none !important;

  min-height: 0 !important;

  max-height: none !important;

  width: 100%;

  height: 100%;

  image-orientation: 0deg;
}

.cropper-wrap-box,
.cropper-canvas,
.cropper-drag-box,
.cropper-crop-box,
.cropper-modal {
  position: absolute;

  top: 0;

  right: 0;

  bottom: 0;

  left: 0;
}

.cropper-wrap-box {
  overflow: hidden;
}

.cropper-drag-box {
  opacity: 0;

  background-color: #fff;
}

.cropper-modal {
  opacity: 0.5;

  background-color: #000;
}

.cropper-view-box {
  display: block;

  overflow: hidden;

  width: 100%;

  height: 100%;

  outline: 1px solid #39f;

  outline-color: rgba(51, 153, 255, 0.75);
}

.cropper-dashed {
  position: absolute;

  display: block;

  opacity: 0.5;

  border: 0 dashed #eee;
}

.cropper-dashed.dashed-h {
  top: 33.33333%;

  left: 0;

  width: 100%;

  height: 33.33333%;

  border-top-width: 1px;

  border-bottom-width: 1px;
}

.cropper-dashed.dashed-v {
  top: 0;

  left: 33.33333%;

  width: 33.33333%;

  height: 100%;

  border-right-width: 1px;

  border-left-width: 1px;
}

.cropper-center {
  position: absolute;

  top: 50%;

  left: 50%;

  display: block;

  width: 0;

  height: 0;

  opacity: 0.75;
}

.cropper-center:before,
.cropper-center:after {
  position: absolute;

  display: block;

  content: ' ';

  background-color: #eee;
}

.cropper-center:before {
  top: 0;

  left: -3px;

  width: 7px;

  height: 1px;
}

.cropper-center:after {
  top: -3px;

  left: 0;

  width: 1px;

  height: 7px;
}

.cropper-face,
.cropper-line,
.cropper-point {
  position: absolute;

  display: block;

  width: 100%;

  height: 100%;

  opacity: 0.1;
}

.cropper-face {
  top: 0;

  left: 0;

  background-color: #fff;
}

.cropper-line {
  background-color: #39f;
}

.cropper-line.line-e {
  top: 0;

  right: -3px;

  width: 5px;

  cursor: e-resize;
}

.cropper-line.line-n {
  top: -3px;

  left: 0;

  height: 5px;

  cursor: n-resize;
}

.cropper-line.line-w {
  top: 0;

  left: -3px;

  width: 5px;

  cursor: w-resize;
}

.cropper-line.line-s {
  bottom: -3px;

  left: 0;

  height: 5px;

  cursor: s-resize;
}

.cropper-point {
  width: 5px;

  height: 5px;

  opacity: 0.75;

  background-color: #39f;
}

.cropper-point.point-e {
  top: 50%;

  right: -3px;

  margin-top: -3px;

  cursor: e-resize;
}

.cropper-point.point-n {
  top: -3px;

  left: 50%;

  margin-left: -3px;

  cursor: n-resize;
}

.cropper-point.point-w {
  top: 50%;

  left: -3px;

  margin-top: -3px;

  cursor: w-resize;
}

.cropper-point.point-s {
  bottom: -3px;

  left: 50%;

  margin-left: -3px;

  cursor: s-resize;
}

.cropper-point.point-ne {
  top: -3px;

  right: -3px;

  cursor: ne-resize;
}

.cropper-point.point-nw {
  top: -3px;

  left: -3px;

  cursor: nw-resize;
}

.cropper-point.point-sw {
  bottom: -3px;

  left: -3px;

  cursor: sw-resize;
}

.cropper-point.point-se {
  right: -3px;

  bottom: -3px;

  width: 20px;

  height: 20px;

  cursor: se-resize;

  opacity: 1;
}

@media (min-width: 768px) {
  .cropper-point.point-se {
    width: 15px;

    height: 15px;
  }
}

@media (min-width: 992px) {
  .cropper-point.point-se {
    width: 10px;

    height: 10px;
  }
}

@media (min-width: 1200px) {
  .cropper-point.point-se {
    width: 5px;

    height: 5px;

    opacity: 0.75;
  }
}

.cropper-point.point-se:before {
  position: absolute;

  right: -50%;

  bottom: -50%;

  display: block;

  width: 200%;

  height: 200%;

  content: ' ';

  opacity: 0;

  background-color: #39f;
}

.cropper-invisible {
  opacity: 0;
}

.cropper-bg {
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC');
}

.cropper-hide {
  position: absolute;

  display: block;

  width: 0;

  height: 0;
}

.cropper-hidden {
  display: none !important;
}

.cropper-move {
  cursor: move;
}

.cropper-crop {
  cursor: crosshair;
}

.cropper-disabled .cropper-drag-box,
.cropper-disabled .cropper-face,
.cropper-disabled .cropper-line,
.cropper-disabled .cropper-point {
  cursor: not-allowed;
}
</style>